import axiosInstance from "axios";
import store from '../store'

const localizationFactory = function() {
  let promise = axiosInstance
    .get("/services/onboarding/api" + "/localization/getall")
    .then(response => {
      if (
        response.data != null &&
        response.data.localizationList != null &&
        response.data.localizationList.localizationList != null &&
        response.data.localizationList.localizationList.length > 0
      ) {
        var localeMessages = {};
        for (const localInstance of response.data.localizationList
          .localizationList) {
          if (localeMessages[localInstance.countryCode] == undefined) {
            localeMessages[localInstance.countryCode] = {};
          }
          localeMessages[localInstance.countryCode][localInstance.name] =
            localInstance.value;
        }
        return localeMessages;
      } else {
        return {};
      }
    })
    .catch(err => {
      console.log(err);
    })
    .then(data => ({
      install(Vue, options) {
        const localization = Vue.observable({ language: "tr" });
        Object.defineProperty(Vue.prototype, "$localizationLanguage", {
          get() {
            return store.getters['localization'];
          },
          set(value) {
            store.dispatch('setLocalization',value);
            localization.language = value;
          }
        });
        Vue.prototype.$localization = data;
        Vue.prototype.$t = (text, params) => {
          if (
            data != null &&
            data[Vue.prototype.$localizationLanguage] != null &&
            data[Vue.prototype.$localizationLanguage][text] != null
          ) {
            if (params != null) {
              let value = data[Vue.prototype.$localizationLanguage][text];
              let attributes = Object.keys(params);
              if (attributes != null && attributes.length > 0) {
                for (const attribute of attributes) {
                  value = value.replace(
                    new RegExp("{" + attribute + "}"),
                    params[attribute]
                  );
                }
              }
              return value;
            } else {
              return data[Vue.prototype.$localizationLanguage][text];
            }
          }
          return text;
        };
        Vue.prototype.$setLocalizationLanguage = language => {
          Vue.prototype.$localizationLanguage = language;
        };
      }
    }));
  return promise;
};

export default localizationFactory;



// WEBPACK FOOTER //
// ./src/plugins/localization.js